import React, { FC, memo } from 'react';
import { Input, TableCell } from '@material-ui/core';
import { Quotation, QuotationCategory } from 'src/types';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';

interface Props {
  index: number;
  quotation: Quotation;
  category?: QuotationCategory;
  isScreenCapture: Boolean;
}

const Component: FC<Props> = ({
  index,
  quotation,
  category,
  isScreenCapture = false
}) => {
  const { quotationData, onChangeQuantity } = useQuotationProduct();

  const onHandleChangeQuantity = (
    index: number,
    quotation: Quotation[],
    category: QuotationCategory,
    newValue: number
  ) => {
    onChangeQuantity(index, quotation, category, newValue);
  };

  // Get current quantity from state or default to 1
  const currentQuantity = quotation?.quantity || 1;

  return (
    <TableCell
      style={{
        padding: 0,
        height: '60px',
        minWidth: '40px',
        width: '40px',
        paddingLeft: isScreenCapture ? '25px' : '5px'
      }}
    >
      <Input
        disabled={quotation.product.category_name === 'VOUCHER'}
        disableUnderline
        style={{ width: '50px' }}
        type="number"
        name="quantity"
        value={currentQuantity}
        inputProps={{
          max: 99,
          min: 1,
          style: { textAlign: 'center' }
        }}
        onFocus={(e) => e.stopPropagation()}
        onChange={(e) => {
          const value = parseInt(e.target.value, 10) || 1;
          onHandleChangeQuantity(index, quotationData, category || {}, value);
        }}
      />
    </TableCell>
  );
};

export const QuotationQuantityCell = memo(Component);
